import DevHubPromo from "./devhub-promo"
import recipes from "@content/saas_fiddle_recipes.json"

export default function DevHubPromoSaas() {
  return <DevHubPromo recipes={recipes} />
}
